<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Aftrekbare zorgkosten
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                Het gaat bij de aftrekbare zorgkosten om kosten voor:
                <li class="list">behandelkosten (geneeskundige hulp)</li>
                <li class="list">medicijnen (op doktersvoorschrift)</li>
                <li class="list">hulpmiddelen en aanpassingen</li>
                <li class="list">kosten voor extra gezinshulp</li>
                <li class="list">dieet op voorschrift van arts of diëtist</li>
                <li class="list">vervoer, zoals reiskosten naar een huisarts of ziekenhuis</li>
                <li class="list">extra uitgaven voor kleding en beddengoed</li>
                <li class="list">reiskosten ziekenbezoek</li>
                <div class="space10"></div>
                Deze uitgaven mag je onder bepaalde voorwaarden aftrekken.
                <div class="space10"></div>

                Vul alleen het deel van de kosten in waarvoor je geen vergoeding kreeg.
                <div class="space10"></div>

                Van het totaal van de aftrekbare kosten mag je alleen het deel aftrekken dat uitkomt boven een bepaald
                bedrag, de drempel voor zorgkosten.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button aria-controls="collapse2" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse2" data-bs-toggle="collapse" type="button">
                Niet-aftrekbare zorgkosten
            </button>
        </h2>
        <div aria-labelledby="heading2" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse2">
            <div class="accordion-body">
                Niet-aftrekbare zorgkosten zijn bijvoorbeeld:
                <li class="list">de premies voor je basisverzekering</li>
                <li class="list">de premies voor je aanvullende zorgverzekering.<br/>
                    De premies zijn ook niet aftrekbaar als de aanvullende zorgverzekering kosten dekt die je wel zou
                    kunnen aftrekken als ze zonder die aanvullende verzekering voor je eigen rekening komen.
                </li>
                <li class="list">de kosten die onder een verplicht of vrijwillig eigen risico vallen</li>
                <li class="list">je wettelijke eigen bijdragen aan het CAK:<br/>
                    - op basis van de Wet maatschappelijke ondersteuning (Wmo) voor bijvoorbeeld hulp in de
                    huishouding<br/>
                    - voor Zorg zonder Verblijf (voorheen thuiszorg)<br/>
                    - voor Zorg met Verblijf. <br/>Je woont dan (tijdelijk) in een zorginstelling en je krijgt daar
                    zorg.
                </li>
                <li class="list">eigen bijdragen volgens de Zorgverzekeringswet</li>
                <li class="list">uitgaven voor een ivf-behandeling als je op het moment van de behandeling 43 jaar of
                    ouder bent
                </li>
                <li class="list">uitgaven voor de 1e 2 ivf-behandelingen als meer dan 1 embryo per poging wordt
                    teruggeplaatst, en u
                    op het moment van de behandeling jonger bent dan 38 jaar
                </li>
                <li class="list"> uitgaven voor een combinatietest in het kader van prenatale screening indien geen
                    sprake is van een
                    medische indicatie
                </li>
                <li class="list">verhuizing naar een verzorgingshuis en de inrichting van de nieuwe woonruimte</li>
                <li class="list">een telefoonabonnement of gesprekskosten</li>
                <li class="list">de inkomensafhankelijke bijdrage Zorgverzekeringswet die je werkgever betaalt of die de
                    uitkeringsinstantie op je uitkering inhoudt
                </li>
                <li class="list">uitgaven die ook al aftrekbaar zijn als uitgaven voor tijdelijk verblijf thuis van
                    gehandicapten
                </li>
                <li class="list">uitgaven voor geestelijke gezondheidszorg voor een persoon die de leeftijd van 18 jaar
                    nog niet
                    heeft bereikt
                </li>
                <li class="list">uitgaven voor dyslexiezorg voor een persoon die de leeftijd van 18 jaar nog niet heeft
                    bereikt
                </li>

                <li class="list">uitgaven voor een scootmobiel, rolstoel en rollator, een loophulp met 3 of 4 poten, een
                    elleboogkruk, een gipssteun, een sta- op stoel, een looprek, een okselkruk of een onderarmschaalkruk
                </li>
                <li class="list">aanpassingen aan, in of om een woning, woonboot, woonwagen of een aanhorigheid daarvan.<br/>
                    Onder een aanhorigheid verstaan wij zaken die zich bevinden op de grond waarop de woning staat,
                    bijvoorbeeld een schuur, garage of een tuin.
                </li>
                <li class="list">kosten van een gezinshulp die zijn verwerkt in de pensionprijs van een
                    Wlz-instellingInstelling van
                    zorgaanbieder die hulp of zorg biedt op basis van de Wet langdurige zorg.
                </li>
                <li class="list">uitgaven voor producten ter voorkoming van een ziekte</li>
                <li class="list">uitgaven om zorg te voorkomen, bijvoorbeeld uitgaven voor een sportkeuring.<br/>
                    Deze uitgaven zijn meestal niet aftrekbaar. Er geldt een uitzondering voor de uitgaven voor
                    reisvaccinaties. Deze mag je wel aftrekken. De aard van de reis doet er niet toe: zowel de kosten
                    van vaccinaties voor een vakantiereis als voor een zaken- of studiereis zijn aftrekbaar.
                </li>
                <li class="list">uitgaven voor hulpmiddelen ter ondersteuning van het gezichtsvermogen.<br/>
                    Het gaat hierbij om hulpmiddelen zoals brillen, contactlenzen en contactlensvloeistof. Dit geldt ook
                    voor de kosten van ooglaserbehandelingen ter vervanging van een bril of contactlenzen. De kosten van
                    een bril met prismaglazen die het gezichtsvermogen niet ondersteunt zijn wel aftrekbaar.
                </li>
                <li class="list">kosten die je maakt voor niet-gecontracteerde zorg.<br/>
                    Je hebt kosten voor zorg die wel onder de basisverzekering valt, maar niet (volledig) wordt vergoed,
                    omdat je geen gebruik maakt van gecontracteerde zorg.
                </li>
                <li class="list">uitgaven voor een maatwerkvoorziening (incl. persoonsgebonden budgetten) als je geen
                    beroep doet op
                    de vergoeding of verstrekking die je daarvoor op grond van de WMO (Wet maat­schappelijke
                    ondersteuning 2015) had kunnen krijgen;
                </li>
                <li class="list">kosten voor het gebruik van niet-gecontracteerde zorg</li>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button aria-controls="collapse3" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse3" data-bs-toggle="collapse" type="button">
                Voor wie mag je zorgkosten aftrekken
            </button>
        </h2>
        <div aria-labelledby="heading3" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse3">
            <div class="accordion-body">
                Je mag de uitgaven bij ziekte of invaliditeit aftrekken voor:

                <li class="list">jezelf en je fiscale partner</li>
                <li class="list">uw kinderen jonger dan 27 jaar als deze kinderen niet in staat zijn de kosten zelf te
                    betalen
                </li>
                <div class="space10"></div>
                Je mag ook de kosten die je betaalt voor de volgende personen aftrekken, als zij niet in staat zijn
                om deze zelf te betalen:
                <li class="list">gehandicapte personen van 27 jaar of ouder waarmee je in gezinsverband woont.<br/>
                    Iemand is gehandicapt als diegene aanspraak kan maken op opname in een Wlz-instellingInstelling van
                    zorgaanbieder die hulp of zorg biedt op basis van de Wet langdurige zorg.
                </li>
                <li class="list">ouders, de kinderen van die ouders die bij je in huis wonen en afhankelijk zijn van uw
                    zorg.<br/>
                    Als je de zorg niet verleent, zou deze persoon beroepsmatige hulp of verzorging in een verzorgings-
                    of verpleeghuis nodig hebben.
                </li>


            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button aria-controls="collapse5" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse5" data-bs-toggle="collapse" type="button">
                Behandelkosten (geneeskundige hulp)
            </button>
        </h2>
        <div aria-labelledby="heading5" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse5">
            <div class="accordion-body">
                Vul de kosten in die je niet vergoed hebt gekregen voor de volgende soorten geneeskundige hulp:
                <li class="list">huisarts, tandarts of specialist</li>
                <li class="list">behandelingen door een paramedicus
                    Als de Belastingdienst erom vraagt, moet je een verklaring van de paramedicus hebben waaruit het
                    medische karakter van de behandeling(en) blijkt
                </li>
                <li class="list">verpleging in een ziekenhuis of een andere verpleeginstelling</li>
                <li class="list">behandelingen op voorschrift en onder begeleiding van een arts, bijvoorbeeld
                    acupunctuur,
                    revalidatie en homeopathie
                </li>
                <div class="space10"></div>

                Paramedici waarvoor geen verwijzing door arts nodig is:
                <li class="list">fysiotherapeut</li>
                <li class="list">diëtist</li>
                <li class="list">ergotherapeut</li>
                <li class="list">logopedist</li>
                <li class="list">oefentherapeut</li>
                <li class="list">orthoptist</li>
                <li class="list">podotherapeut</li>
                <li class="list">mondhygiënist</li>
                <li class="list">huidtherapeut</li>
                <div class="space10"></div>

                <b>Wat moet je niet hier invullen?</b><br/>
                <li class="list">het deel van de kosten waarvoor je een vergoeding krijgt</li>
                <li class="list">kosten die onder een verplicht of vrijwillig eigen risico vallen</li>
                <li class="list">eigen bijdragen volgens de Zorgverzekeringswet</li>
                <li class="list">kosten van ooglaserbehandelingen ter vervanging van een bril of contactlenzen</li>
                <li class="list">kroon geplaatst op een implantaat.<br/>
                    Kosten voor een kroon geplaatst op een implantaat en het plaatsen hiervan vult je in bij
                    'Hulpmiddelen'.
                </li>
                <li class="list">uitgaven voor een ivf-behandeling als je op het moment van de behandeling 43 jaar of
                    ouder bent
                </li>
                <li class="list">uitgaven voor de 1e 2 ivf-behandelingen als meer dan 1 embryo per poging wordt
                    teruggeplaatst, en je
                    op het moment van de behandeling jonger bent dan 38 jaar
                </li>
                <li class="list">uitgaven voor een combinatietest in het kader van prenatale screening indien geen
                    sprake is van een
                    medische indicatie
                </li>
                <div class="space10"></div>

                <b>Was je niet verzekerd?</b><br/>
                Heb je kosten gemaakt die je niet vergoed hebt gekregen omdat je geen zorgverzekering had
                afgesloten? Dan mag je de kosten van ziekte en invaliditeit die onder de basisverzekering vallen
                niet invullen. Kosten die vallen onder de aanvullende verzekering mag je wel invullen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button aria-controls="collapse6" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse6" data-bs-toggle="collapse" type="button">
                Medicijnen (op doktersvoorschrift)
            </button>
        </h2>
        <div aria-labelledby="heading6" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse6">
            <div class="accordion-body">
                Vul alleen de kosten in voor medicijnen die je als geneesmiddel hebt gebruikt. Deze medicijnen moeten
                door een bevoegde arts zijn voorgeschreven. Dit kunnen ook homeopathische medicijnen zijn.
                <div class="space10"></div>
                Was het medicijn voorgeschreven door een arts buiten Nederland? Dan moet deze arts een vergelijkbare
                bevoegdheid hebben als artsen die in Nederland bevoegd zijn.
                <div class="space10"></div>
                Vul alleen de kosten in van het deel waarvoor je geen vergoeding hebt gekregen.
                <div class="space10"></div>

                <b>Wat moet je niet hier invullen?</b><br/>
                <li class="list">kosten voor producten die je hebt gebruikt om een ziekte te voorkomen</li>
                <li class="list">kosten die onder een verplicht of vrijwillig eigen risico vallen</li>
                <li class="list">eigen bijdragen volgens de Zorgverzekeringswet</li>
                <div class="space10"></div>

                Op <a href="https://www.medicijnkosten.nl" target="_blank">www.medicijnkosten.nl</a> kun je opzoeken of
                je voor een medicijn dat je gebruikt een eigen bijdrage moet betalen.
                <div class="space10"></div>

                <b>Was je niet verzekerd?</b><br/>
                Heb je kosten gemaakt die je niet vergoed hebt gekregen omdat je geen zorgverzekering had
                afgesloten? Dan mag je de kosten van ziekte en invaliditeit die onder de basisverzekering vallen
                niet invullen. Kosten die vallen onder de aanvullende verzekering mag je wel invullen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button aria-controls="collapse7" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse7" data-bs-toggle="collapse" type="button">
                Hulpmiddelen en aanpassingen
            </button>
        </h2>
        <div aria-labelledby="heading7" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse7">
            <div class="accordion-body">
                Hulpmiddelen zijn voorzieningen of apparaten die hoofdzakelijk door zieke of invalide personen worden
                gebruikt. Het kan gaan om een hulpmiddel dat je in staat stelt om een normale lichaamsfunctie te
                verrichten, zoals een prothese of een hoortoestel.
                <div class="space10"></div>

                Onder aanpassingen verstaat de Belastingdienst zaken die zieke of invalide personen kunnen gebruiken en
                die speciaal voor hen zijn aangebracht, zoals een aanpassing aan het stuursysteem van een auto.
                <div class="space10"></div>

                <b>Aftrekbare uitgaven hulpmiddelen</b><br/>
                Je mag bijvoorbeeld uitgaven voor de volgende hulpmiddelen invullen:<br/>
                <li class="list">steunzolen</li>
                <li class="list">kunstgebit en prothesen</li>
                <li class="list">kroon (geplaatst op een implantaat) en brug. Kosten voor een kroon geplaatst op een
                    afgeslepen
                    tand of kies en het plaatsen hiervan vul je in bij 'Behandelkosten'.
                </li>
                <li class="list">hulphond, bijvoorbeeld een blindengeleidehond of een signaalhond.
                </li>
                <li class="list">onderhoud, reparatie en verzekering van deze hulpmiddelen</li>
                <li class="list">een 'vingerprik' om bloedwaarden te meten zonder hulp van een arts of verpleegkundige
                </li>
                <li class="list">een alarmsysteem in verband met een specifieke ziekte. Bijvoorbeeld een detectie- en
                    alarmeringsapparaat ontwikkeld voor mensen met epilepsie.
                </li>
                <li class="list">een stomadouche</li>
                <li class="list">gehoorapparaten</li>
                <div class="space10"></div>

                <b>Gehoorapparaat</b><br/>
                Een gehoorapparaat mag je alleen in zeer specifieke situaties aftrekken. Schaf je een gehoorapparaat
                aan en moet je een deel zelf betalen? Dan mag je misschien een deel van het bedrag dat je zelf betaalt
                aftrekken. Het gaat dan om het deel dat je zelf betaalt, omdat je een meerprijs moet betalen. Je mag het
                bedrag van de meerprijs alleen aftrekken als aan de volgende 2 voorwaarden is voldaan:
                <li class="list">de meerprijs is ontstaan omdat je een duurder apparaat wilde hebben</li>
                <li class="list">De functionele eisen van dat duurdere gehoorapparaat zijn voor je beter. Het apparaat
                    zit
                    bijvoorbeeld
                    prettiger. Of je hebt minder last van fluittonen met het duurdere hoorapparaat.
                </li>
                <div class="space10"></div>
                Let op! Betaal je een meerprijs door een persoonlijke voorkeur, zoals de kleur van een apparaat? Dan is
                het bedrag van de meerprijs niet aftrekbaar.

                <b>Wat moet je niet hier invullen?</b><br/>
                De wettelijke eigen bijdrage die je voor sommige ziektekosten moest betalen, bijvoorbeeld voor een
                hoortoestel of bij kraamzorg, mag je niet invullen. Dit geldt ook voor het verplicht en vrijwillig eigen
                risico.
                <div class="space10"></div>

                <i>Lees hierboven bij 'Niet-aftrekbare zorgkosten' ook welke hulpmiddelen je daarnaast niet mag
                    aftrekken.</i>
                <div class="space10"></div>

                <b>Hulpmiddelen gezichtsvermogen</b><br/>
                Je mag alleen de uitgaven invullen voor hulpmiddelen die je nodig had omdat je blind of slechtziend
                bent. Bijvoorbeeld de kosten van een blindenstok, een blindengeleidehond of bepaalde aanpassingen aan
                een computer.<br/>
                Vul hier dus niet in:
                <li class="list">de uitgaven voor hulpmiddelen ter ondersteuning van het gezichtsvermogen. Het gaat
                    hierbij om
                    hulpmiddelen zoals brillen, contactlenzen en contactlensvloeistof.
                </li>
                <li class="list">de kosten van ooglaserbehandelingen ter vervanging van een bril of contactlenzen</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button aria-controls="collapse8" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse8" data-bs-toggle="collapse" type="button">
                Kosten extra gezinshulp
            </button>
        </h2>
        <div aria-labelledby="heading8" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse8">
            <div class="accordion-body">
                Dit betreft de uitgaven voor extra gezinshulp die je nodig had vanwege ziekte of invaliditeit. Je hebt
                hiervoor de rekeningen of kwitanties nodig, waarop de volgende gegevens staan: datum + bedrag + naam,
                adres en woonplaats van de gezinshulp of instantie aan wie je de kosten betaalde.<br/>
                Vul alleen de kosten in van het deel waarvoor je geen vergoeding kreeg.
                <div class="space10"></div>
                Woonde je in een Wlz-instelling? Vul hier dan alleen kosten in die gemaakt zijn voor je of je fiscale
                partner persoonlijk. Deze kosten moeten afzonderlijk in rekening zijn gebracht. Vul hier dus geen kosten
                in die voor alle bewoners gezamenlijk zijn gemaakt en door de instelling over alle bewoners zijn
                verdeeld.
                <div class="space10"></div>

                <b>Wat moet je niet hier invullen?</b><br/>
                Je wettelijke eigen bijdrage aan het Centraal Administratiekantoor (CAK):
                <li class="list">op basis van de Wet maatschappelijke ondersteuning (Wmo) voor bijvoorbeeld hulp in de
                    huishouding
                </li>
                <li class="list">voor Zorg zonder Verblijf (voorheen thuiszorg)</li>
                <li class="list">voor Zorg met Verblijf. Je woont dan (tijdelijk) in een zorginstelling en je krijgt
                    daar zorg.
                </li>
                <div class="space10"></div>

                Er geldt een drempel voor de uitgaven voor extra gezinshulp. Dit 1%, 2% of 3% van het drempelinkomen,
                afhankelijk van de hoogte van het drempelinkomen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button aria-controls="collapse9" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse9" data-bs-toggle="collapse" type="button">
                Dieetkosten
            </button>
        </h2>
        <div aria-labelledby="heading9" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse9">
            <div class="accordion-body">
                Je hebt recht op een vaste aftrek voor bepaalde diëten op voorschrift van een dokter of diëtist. Het
                gaat dan om diëten voor ziektes en aandoeningen en niet om diëten voor bijvoorbeeld overgewicht.
                <div class="space10"></div>

                Je kunt uit een lijst selecteren voor welke diëten je kosten maakte. Geef daarbij ook aan voor welke
                periode het dieet gold. Wil je de dieetlijst op de site van de Belastingdienst bekijken? Klik dan <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/relatie_familie_en_gezondheid/gezondheid/aftrek_zorgkosten/overzicht_zorgkosten/dieetkosten/dieetlijsten/"
                    target="_blank">hier</a>.
                <div class="space10"></div>

                De Belastingdienst kan je vragen om een dieetbevestiging. Je kunt deze downloaden van
                <a href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/relatie_familie_en_gezondheid/gezondheid/aftrek_zorgkosten/overzicht_zorgkosten/dieetkosten/dieetbevestiging"
                   target="_blank">belastingdienst.nl</a>.
                De arts of diëtist vult de bevestiging in.
                <div class="space10"></div>

                Het programma berekent de aftrek voor je op basis van de ingevulde gegevens.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button aria-controls="collapse10" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse10" data-bs-toggle="collapse" type="button">
                Reiskosten eigen zorg
            </button>
        </h2>
        <div aria-labelledby="heading10" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse10">
            <div class="accordion-body">
                Het gaat hier om de reiskosten:
                <li class="list">voor vervoer naar een arts of ziekenhuis</li>
                <li class="list">voor vervoer naar een apotheek om door een arts voorgeschreven
                    medicijnen/farmaceutische
                    hulpmiddelen op
                    te halen
                </li>
                <li class="list">voor ambulancevervoer</li>
                <li class="list">die je extra maakte door ziekte of invaliditeit</li>
                <div class="space10"></div>

                <b>Wat zijn reiskosten?</b><br/>
                Bij de berekening van de werkelijke reiskosten mag je de volgende kosten meetellen:
                <li class="list">autokosten.<br/>
                    Vul de prijs per km in (in centen). Het gaat om de werkelijke kosten voor de kilometers die je hebt
                    gereden. Voor het bepalen van de
                    kilometerprijs kunt je gebruik maken van algemene schattingen, zoals de <a
                            href="https://www.anwb.nl/auto/autokosten"
                            target="_blank">rekentool
                        van de ANWB</a>.
                    Daarvoor is wel van belang dat de standaardschatting uit de rekentool voldoende overeenkomt met je
                    situatie. Parkeergelden mag je niet meetellen als die al in de kilometerprijs van de auto zijn
                    begrepen.
                </li>
                <li class="list">taxikosten</li>
                <li class="list">kosten voor openbaar vervoer</li>
                <div class="space10"></div>

                <b> Extra reiskosten door ziekte of invaliditeit</b><br/>
                <div *ngIf="this.year < 2025">
                    Vul deze extra reiskosten in als je aannemelijk kunt maken dat je door je ziekte of invaliditeit
                    hogere
                    reiskosten had dan mensen die niet ziek of invalide zijn en die in financieel en maatschappelijk
                    opzicht
                    vergelijkbaar zijn met jou. Je kunt daarvoor gebruikmaken van gegevens van bijvoorbeeld het NIBUD of
                    het
                    CBS.<br/>
                    Je moet van deze extra reiskosten wel de vergoeding aftrekken die je bijvoorbeeld van uw
                    zorgverzekering
                    hebt gekregen. Ook reiskosten die je al hebt afgetrokken als hulpmiddel (bijvoorbeeld een aanpassing
                    van
                    uw auto vanwege invaliditeit) of als reiskosten naar een arts of een ziekenhuis moet je van deze
                    extra
                    reiskosten aftrekken.
                </div>


                <div *ngIf="this.year > 2024">
                    Je mag een vast bedrag van € 925 aftrekken als je kunt aantonen dat de belastingplichtige niet meer
                    dan 100 meter zelfstandig kunt lopen. Dit kan bijvoorbeeld door middel van een
                    gehandicaptenparkeerkaart, een
                    aanvraag bij de gemeente voor een mobiliteitsvoorziening uit de WMO of PGB, of een verklaring van
                    een arts. Eventuele vergoedingen voor extra vervoerskosten die de persoon krijgt of kan krijgen,
                    moet je van het vaste bedrag van € 925 aftrekken.
                </div>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading11">
            <button aria-controls="collapse11" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse11" data-bs-toggle="collapse" type="button">
                Extra uitgaven kleding en beddengoed
            </button>
        </h2>
        <div aria-labelledby="heading11" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse11">
            <div class="accordion-body">
                Het gaat hier om de extra uitgaven voor (het wassen van) kleding en beddengoed.
                Je mag deze uitgaven aftrekken als:
                <li class="list">de kosten een rechtstreeks gevolg waren van (uw) ziekte of invaliditeit</li>
                <li class="list">de ziekte minimaal 1 jaar duurde of waarschijnlijk minimaal 1 jaar gaat duren</li>
                <div class="space10"></div>

                <div *ngIf="this.year === 2024">
                    Voor deze uitgaven mag je een vast bedrag aftrekken van € 350. Kun je aantonen dat de extra uitgaven
                    hoger waren dan € 700? Dan mag je € 875 aftrekken. De bedragen gelden per persoon en voor een heel
                    jaar.
                </div>
                <div *ngIf="this.year === 2025">
                    Voor deze uitgaven mag je een vast bedrag aftrekken van € 340. Kun je aantonen dat de extra uitgaven
                    hoger waren dan € 680? Dan mag je € 850 aftrekken. De bedragen gelden per persoon en voor een heel
                    jaar.
                </div>
                <div *ngIf="this.year === 2026">
                    Voor deze uitgaven mag je een vast bedrag aftrekken van € 330. Kun je aantonen dat de extra uitgaven
                    hoger waren dan € 660? Dan mag je € 825 aftrekken. De bedragen gelden per persoon en voor een heel
                    jaar.
                </div>
                <div class="space10"></div>
                Het bedrag dat je mag aftrekken moet gelijk zijn aan de periode dat je ziek was. <br/>
                <div class="space10"></div>

                Als je als co-ouder de helft van de kosten op je neemt (en de andere co-ouder de andere helft), trek je
                50% van het bedrag af dat je zou mogen aftrekken als je het hele bedrag zou mogen aftrekken.
                <div class="space10"></div>

                Tel alleen de uitgaven mee waarvoor je geen vergoeding kreeg. Het programma berekent daarna de aftrek
                voor je
                op basis van de ingevulde gegevens.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button aria-controls="collapse12" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse12" data-bs-toggle="collapse" type="button">
                Reiskosten voor ziekenbezoek
            </button>
        </h2>
        <div aria-labelledby="heading12" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse12">
            <div class="accordion-body">
                Vul hier de reiskosten voor ziekenbezoek in. Vul alleen de kosten in van het deel waarvoor je geen
                vergoeding kreeg.
                <div class="space10"></div>

                <b>Aftrekbare kosten voor ziekenbezoek</b><br/>
                <li class="list">reisde je met de auto? Dan geldt een vast bedrag van
                    € {{ this.kmPrijs | number:'1.2-2' }} per
                    kilometer.
                </li>
                <li class="list">reisde je met de taxi, met het openbaar vervoer of op een andere manier? Vul dan de
                    werkelijke
                    reiskosten in.
                </li>
                <div class="space10"></div>

                <b>Voorwaarden voor aftrek</b>
                <li class="list">je en de zieke hadden bij het begin van de ziekte samen een huishouden.</li>
                <li class="list">je bezocht de zieke in {{ this.year }} regelmatig.</li>
                <li class="list">de zieke werd langer dan 1 maand verpleegd. Werd de zieke meerdere keren per jaar
                    verpleegd? Dan mag
                    je de reiskosten alleen aftrekken als de zieke in totaal langer dan 1 maand werd verpleegd en als de
                    verpleging steeds een gevolg was van dezelfde ziekte. Bovendien mag de tijd tussen de
                    verpleegperioden niet langer dan 4 weken zijn.
                </li>
                <li class="list">de afstand van een enkele reis tussen je woning of verblijfplaats en de plaats waar de
                    zieke werd
                    verpleegd (gemeten langs de meest gebruikelijke weg) is meer dan 10 kilometer.
                </li>
            </div>
        </div>
    </div>

</div>


